import { openBlock as l, createElementBlock as t, createElementVNode as c } from "vue";
const o = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
};
function n(r, e) {
  return l(), t("svg", o, [...e[0] || (e[0] = [
    c("path", {
      fill: "currentColor",
      d: "M13.2 2.16q.59.222 1.17.465c1.802.75 3.514 1.022 5.458 1.133.572.082.572.082 1.292.562.076.704.107 1.357.104 2.063l.004.626v1.317c-.003.665.004 1.33.011 1.994.017 4.159.017 4.159-1.079 6l-.385.648c-1.494 1.878-3.216 3.105-5.3 4.257l-.458.258c-.962.51-1.655.763-2.737.597-.692-.26-1.332-.59-1.98-.945l-.545-.296c-2.621-1.468-4.499-3.289-5.648-6.097-.286-1.034-.3-1.978-.3-3.046l-.002-.636q-.003-.662 0-1.324-.002-1.015-.012-2.032V6.416l-.007-.615c.005-.568.005-.568.094-1.481.835-.556 1.494-.59 2.46-.675 2.584-.268 5.395-2.085 7.86-1.485M9.002 4.73c-1.436.469-2.949.604-4.442.79q-.036 1.575-.053 3.15-.006.534-.02 1.068c-.061 2.685.083 5.004 1.978 7.092 1.598 1.672 3.64 3.218 6.015 3.33 2.473-.726 4.99-2.804 6.27-5.031.888-1.932.799-3.845.75-5.919q-.008-.54-.013-1.077a242 242 0 0 0-.047-2.613l-.852-.124c-1.942-.295-3.768-.6-5.589-1.371-1.41-.502-2.676.218-3.997.706"
    }, null, -1)
  ])]);
}
const d = { render: n };
export {
  d as default,
  n as render
};
